import { AskMethodType } from "./type";

// 问诊方式
export const askMethodTypes = [
  {
    label: "一键问诊",
    value: AskMethodType.NORMAL
  },
  {
    label: "图文问诊",
    value: AskMethodType.IMAGE
  },
  {
    label: "视频问诊",
    value: AskMethodType.VIDEO
  },
  {
    label: "线下门诊",
    value: AskMethodType.STORE
  },
  {
    label: "图文问诊",
    value: AskMethodType.PHONE
  },
];
